module.exports = __webpack_public_path__ + "img/couples_09_V.832471f2.jpg";